/**
 * Eén kerngetal met zijn context.
 *
 * @param {object} props
 * @param {(number|null)} props.value - het getal zelf
 * @param {(string|null)} [props.unit] - eenheid achter het getal
 * @param {(number|null)} [props.n] - respondenten erachter
 * @param {(number|null)} [props.orgs] - organisaties erachter
 * @param {boolean} [props.measurable] - false = er was niets te meten (≠ uitkomst nul)
 */
const NumberRender = ({ value, unit, n, orgs, measurable = true }) => {
    // Leeg is geen nul: een dataset zonder metingen levert netjes 0 op, maar
    // die nul betekent "we hebben niets gemeten".
    // AI-CONTEXT: See docs/patterns.md#backend-empty-dataset-is-not-a-zero
    if (measurable === false || typeof value !== 'number') {
        return <p className="intelligence-state">Er is nog niet genoeg gemeten om hier iets over te zeggen.</p>
    }

    return (
        <div className="intelligence-number">
            <span className="intelligence-number__value">
                {value.toFixed(2)}{unit ? ` ${unit}` : ''}
            </span>
            <span className="intelligence-number__context">
                {typeof n === 'number' ? `${n} respondenten` : 'aantal respondenten onbekend'}
                {typeof orgs === 'number' ? ` · ${orgs} organisaties` : ''}
            </span>
        </div>
    )
}

export default NumberRender
